import { render } from "./First.vue?vue&type=template&id=70116b5c&scoped=true"
import script from "./First.vue?vue&type=script&lang=js"
export * from "./First.vue?vue&type=script&lang=js"

import "./First.vue?vue&type=style&index=0&id=70116b5c&scoped=true&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70116b5c"]])

export default __exports__